import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    QuestionGroupListDto,
    CreateQuestionGroupEntryDto,
    UpdateQuestionGroupDto,
    QuestionGroupDetailDto
} from '../../../core/data/new-dtos/insurance-type.dtos';
@Injectable({
    providedIn: 'root',
})
export class QuestionGroupsService {
    private baseUrl = 'QuestionGroups';

    constructor(private http: HttpClient) { }

    getAll(): Observable<QuestionGroupListDto[]> {
        return this.http.get<QuestionGroupListDto[]>(this.baseUrl);
    }

    create(dto: CreateQuestionGroupEntryDto): Observable<number> {
        return this.http.post<number>(this.baseUrl, dto);
    }

    getById(id: number): Observable<QuestionGroupDetailDto> {
        return this.http.get<QuestionGroupDetailDto>(`${this.baseUrl}/${id}`);
    }

    update(id: number, dto: UpdateQuestionGroupDto): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/${id}`, dto);
    }
}
